import { validateFor, validateAs } from "app/server/validation/decorators";
import { IncomingMessage, MessageTag } from "../general";
import { AuthenticatedChannelDetails } from "../admin/clients-status-response";

/**
 * The {@link ActiveSessionsResponse} provides a summary of all of the user's
 * current client connections, and the state and authentication details of each.
 */
@validateFor(MessageTag.RSP_ACTIVE_SESSIONS)
export class ActiveSessionsResponse extends IncomingMessage
{
    public tag : MessageTag = MessageTag.RSP_ACTIVE_SESSIONS;

    @validateAs("integer")
    public sessionCount : number;

    @validateAs({array: "object"}) // TODO: better validation
    public channels : AuthenticatedChannelDetails[];

}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/server/messages/auth/active-sessions-response.ts